import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Table, Tag } from "antd";
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength, trangThaiDonNghiPhep } from '../../constants';
import { Links } from "../../helpers/Links";
import { menuHelper } from "../../helpers/account";
import { dateCommon, validateMessages } from '../../helpers/common';
import { DonNghiPhep, TimKiemDonNghiPhepRequest } from '../../models/donnghiphep/DonNghiPhep';
import { layDanhSachTongHopTheoThang } from '../../services/donnghiphep';
import dayjs from 'dayjs';

const DanhSachPhepTongHop = () => {
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const menu: any = menuHelper.checkMultiPermission([Links.Phep.ChiTiet, Links.Phep.Xem]);
    const [form] = Form.useForm();

    const [page, setPage] = useState(1);
    const [danhSach, setDanhSach] = useState<Array<DonNghiPhep>>([]);

    const timkiem = async (request: TimKiemDonNghiPhepRequest) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await layDanhSachTongHopTheoThang(request);
            setDanhSach(temp.data);
            setIsLoadingTable(false);
        }
        catch (error: any) {
            toast.error(error);
            setIsLoadingTable(false);
        };
    }

    const OPTIONS = [
        'Ngày tạo',
        'Ngày bắt đầu nghỉ',
        'Ngày kết thúc nghỉ',
        'Từ khóa'
    ];

    const [selectedItems, setSelectedItems] = useState<any[]>(["Ngày tạo"]);

    const handleChange = (e: any, currentIndex: number) => {
        var temp = [...selectedItems];
        temp[currentIndex] = e;
        form.setFieldsValue({
            'tuKhoa': null,
            'ngayTaoTuNgay': null,
            'ngayTaoDenNgay': null,
            'ngayBatDauTuNgay': null,
            'ngayBatDauDenNgay': null,
            'ngayKetThucTuNgay': null,
            'ngayKetThucDenNgay': null
        });
        setSelectedItems(temp);
    }
    useEffect(() => {
        form.setFieldsValue({
            'ngayTaoTuNgay': ngayDauThang,
            'ngayTaoDenNgay': ngayCuoiThang,
            'tuKhoa': null,
            'ngayBatDauTuNgay': null,
            'ngayBatDauDenNgay': null,
            'ngayKetThucTuNgay': null,
            'ngayKetThucDenNgay': null
        });
        var rq = new TimKiemDonNghiPhepRequest;
        rq.ngayTaoTuNgay = ngayDauThang.toDate();
        rq.ngayTaoDenNgay = ngayCuoiThang.toDate();
        timkiem(rq);
    }, []);

    const ngayDauThang = dayjs().startOf('month');
    const ngayCuoiThang = dayjs().endOf('month');
    const renderInput = (item: any) => {
        switch (item) {
            case "Ngày tạo":
                return (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="ngayTaoTuNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="ngayTaoDenNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                );
            case "Ngày bắt đầu nghỉ":
                return (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="ngayBatDauTuNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="ngayBatDauDenNgay">
                                <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                    </Row>
                );
            case "Ngày kết thúc nghỉ":
                return (
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="ngayKetThucTuNgay">
                            <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Từ ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="ngayKetThucDenNgay">
                            <DatePicker changeOnBlur={true} style={{ width: "100%", border: 'none' }} placeholder="--Đến ngày--" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                        </Form.Item>
                        </Col>
                    </Row>
                );
            case "Từ khóa":
                return (<Form.Item name="tuKhoa">
                    <Input allowClear placeholder="--Nhập tên nhân viên, tên phòng ban, loại nghỉ phép--" />
                </Form.Item>);
        }
    }
    const onFinish = (values: any) => {
        var rq = new TimKiemDonNghiPhepRequest;
        rq.ngayTaoTuNgay = values.ngayTaoTuNgay;
        rq.ngayTaoDenNgay = values.ngayTaoDenNgay;
        rq.ngayBatDauTuNgay = values.ngayBatDauTuNgay;
        rq.ngayBatDauDenNgay = values.ngayBatDauDenNgay;
        rq.ngayKetThucTuNgay = values.ngayKetThucTuNgay;
        rq.ngayKetThucDenNgay = values.ngayKetThucDenNgay;
        rq.tuKhoa = values.tuKhoa;
        timkiem(rq);
    }
    const handleKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            form.validateFields().then(async (values) => { onFinish(values); });
        }
    };
    return (
        <section>
            <ContentHeader title="Danh sách đơn nghỉ phép" />
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
                onKeyPress={handleKeyPress}
            >
            <Row gutter={8} className="form-group">
                <Col span={12}>
                    {selectedItems.map((item, index) => {
                        return <Row className="mb-2" gutter={8} key={index} style={{ width: '100%', height: '40px' }}>
                            <Col span="8">
                                <Select
                                    placeholder="--Chọn trường--"
                                    value={item}
                                    onChange={(e) => handleChange(e, index)}
                                    style={{ width: '100%', height: '35px' }}
                                    options={OPTIONS.map((item) => ({
                                        value: item,
                                        label: item,
                                    }))}
                                    showSearch
                                    filterOption={function (search, item: any) {
                                        return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                                    }}
                                />
                            </Col>
                            <Col span="16">
                                {renderInput(item)}
                            </Col>
                        </Row>
                    })}
                </Col>
                <Col span={4}>
                    <Button type="primary" icon={<SearchOutlined rev="" />} htmlType='submit'>
                        Tìm kiếm
                    </Button>
                </Col>
                </Row>
            </Form>
            <Row>
                <Col span="24">
                    <div className="card card-primary">
                        <Table
                            dataSource={(danhSach || []).map((item: any) => { item.key = item.id; return item })}
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            pagination={{
                                current: page,
                                onChange: (page, pageSize) => {
                                    setPage(page);
                                },
                            }}
                        >
                            <Column title="STT" key="STT" width="5%" render={(value, record, index) =>
                                (<span key={"stt" + index}> {(page - 1) * searchLength + index + 1}</span>)
                            } />
                            <Column title="Nhân viên" dataIndex="tenNhanVien" key="tenNhanVien" />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Loại nghỉ" dataIndex="tenLoaiNghiPhep" key="loaiNghiPhep" />
                            <Column title="Từ ngày" dataIndex="tuNgay" key="tuNgay" render={(value, record) =>
                                (<span>{dateCommon.formatDate(value)}</span>)
                            } />
                            <Column title="Đến ngày" width="15%" dataIndex="denNgay" key="denNgay" render={(value, record) =>
                                (<span>{dateCommon.formatDate(value)}</span>)
                            } />
                            <Column title="Tổng số ngày nghỉ" align="center" dataIndex="tongSoNgayNghi" key="tongSoNgayNghi" />
                            <Column title="Trạng thái" width="10%" dataIndex="trangThai" key="trangThai" render={(value, record) => {
                                var tag = (<Tag color="default"></Tag>);
                                switch (value) {
                                    case trangThaiDonNghiPhep.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
                                    case trangThaiDonNghiPhep.trinh: tag = (<Tag color="warning">Trình Lãnh đạo</Tag>); break;
                                    case trangThaiDonNghiPhep.daDuyet: tag = (<Tag color="success">Đã Duyệt</Tag>); break;
                                    case trangThaiDonNghiPhep.tuChoi: tag = (<Tag color="error">Từ chối</Tag>); break;
                                    case trangThaiDonNghiPhep.yKien: tag = (<Tag color="orange">Lấy ý kiến</Tag>); break;
                                    case trangThaiDonNghiPhep.yeuCauHuy: tag = (<Tag color="cyan">Yêu cầu hủy</Tag>); break;
                                    case trangThaiDonNghiPhep.daHuy: tag = (<Tag color="error">Đã hủy</Tag>); break;
                                }
                                return tag;
                            }} />
                            <Column title="" dataIndex="action" key="action" render={(value: any, record: any) => {
                                return menu[Links.Phep.Xem]
                                    ? (<Link className="hrm-btn hrm-btn-sm btn-primary" to={Links.Phep.Xem + "?id=" + record.id}>Xem</Link>)
                                    : "";
                            }} />
                        </Table>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachPhepTongHop;